import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils/common';

import type { TypeOrderDetailOrderInfoData } from '~/types/order.types';

/**
 * [출고주문관리 > 출고 주문 상세] '상품 정보' 테이블
 */
const getOrderDetailProductInfoColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeOrderDetailOrderInfoData>[] = [
    {
      accessorKey: 'itemId',
      header: '상품코드',
      size: 127,
    },
    {
      accessorKey: 'itemName',
      header: '상품명',
      minSize: 240,
      meta: { flex: true },
    },
    {
      accessorKey: 'quantity',
      header: '구매수량',
      size: 79,
      cell: ({ getValue }) => {
        const value = getValue<TypeOrderDetailOrderInfoData['quantity']>();
        return value ? formatNumber(value) : '-';
      },
      meta: { cellStyle: { textAlign: 'right' } },
    },
    {
      accessorKey: 'cancelQuantity',
      header: '취소수량',
      size: 99,
      cell: ({ getValue }) => {
        const value = getValue<TypeOrderDetailOrderInfoData['cancelQuantity']>();
        return value ? formatNumber(value) : '-';
      },
      meta: { cellStyle: { textAlign: 'right' } },
    },
  ];

  return { columnDefs };
};

export default getOrderDetailProductInfoColumnDefs;
